import { createContext } from "react"

const PosCustomerContext = createContext({})

export const PosCustomerProvider = PosCustomerContext.Provider
export const PosCustomerConsumer = PosCustomerContext.Consumer

export default PosCustomerContext
